import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "请妥善保管此二维码", -1);
import { Lock } from '@/entity/Lock';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';
import VueQrcode from 'qrcode.vue';
export default {
  __name: 'lockQR',
  setup(__props) {
    const route = useRoute();
    const data = reactive({
      lock: undefined
    });
    data.lock = Lock.fromUrl(route.params.data);
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_row, {
        justify: "center"
      }, {
        default: _withCtx(() => [_hoisted_1]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "center"
      }, {
        default: _withCtx(() => [_createVNode(VueQrcode, {
          value: data.lock.toString(),
          size: 300
        }, null, 8, ["value"])]),
        _: 1
      })], 64);
    };
  }
};